namespace Areas.Dialogs.ChangePCategory {
    "use strict";

    let budgetId: number
    let reasonText: string;

    export function getRelinkBudgetId() {
        return budgetId;
    }

    export class ChangePCategoryDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void,
            parameters: any = null,
            rootElementId: string = "dialog") {
            super("ChangePCategory",
                closeHandler,
                parameters, () => {
                    budgetId = parameters.budgetId;
                    Areas.refreshGrid(`${this.dialogName}Grid`);
                    const dataGrid = $(`#${this.dialogName}Grid`).dxDataGrid('instance');

                },
                rootElementId);

        }

        protected ok = (e: any) => {

            const textBox: any = $(`#ReasonTextBox`).dxTextBox('instance');

            if (textBox.option("value") != "") {
                reasonText = textBox.option("value");
            } else {
                DevExpress.ui.notify("You must enter a reason", "warning", 2000);
                return;
            }

            const dataGrid = $(`#${this.dialogName}Grid`).dxDataGrid('instance');
            const selectedRows: any = dataGrid.getSelectedRowsData();

            if (selectedRows[0] == null) {
                DevExpress.ui.notify("Please make a selection first!", "warning", 2000);
            } else {

                var data = 
                {
                    "budgetAccountCategoryId": selectedRows[0].budgetAccountCategoryId,
                    "changeReason": reasonText
                };

                this.close(DialogResult.Ok, data);
            }
        }

    }


}

